/* global google */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { leadCall } from '../actions/lead';
import {
  appointementInit,
  appointementClearHours,
  dealerInfo
} from '../actions/appointement';
import GoogleMap from './components/GoogleMap';
import { InputPlaces } from './components/InputPlaces';

var _ = require('lodash');

const unactiveDealer = {
  opacity: 0.5
};
const unactiveBtnStyle = {
  borderColor: '#f4bca4',
  color: '#f4bca4',
  background: '#fff',
  cursor: 'default'
};
const countryRestrict = { country: 'fr' };
class ClassDealer extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this);
    this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderDealer = this.renderDealer.bind(this);
    this.calcCrow = this.calcCrow.bind(this);
    this.toRad = this.toRad.bind(this);
    this.state = {
      isActive: null
    };
    this.state = {
      lat: 48.864716,
      lng: 2.349014,
      isClicked: null,
      dataLead: '',
      dataRest: '',
      data: '',
      zoom: 11,
      formValidate: false,
      markers: [
        {
          position: {
            lat: 48.864716,
            lng: 2.349014
          }
        }
      ],
      isMarkerShown: true,
      center : {
        lat: 48.864716,
        lng: 2.349014
      }
    };
  }
  handleSubmit() {
    var data = this.state.data;
    var dataLead = this.state.dataLead;
    var dataRest = this.state.dataRest;

    console.log(data, dataLead, dataRest);
    if (data != '' && dataLead != '') {
      this.props.leadCall(dataLead, 'leads');
      this.props.appointementInit('ProAccesInit', dataRest, 'dealerInit');
      this.props.dealerInfo(data);
      this.props.appointementClearHours();

      //TRACKING
      var values = {};
      var type = this.props.inquires.home.type;
      values.eventName = 'dealer-choice';
      if (this.props.inquires.home.type == 'achat') {
        this.props.inquires[type]['purchaseTime']['leadName'] === undefined
          ? (values['purchase-intent'] = 'Less than a month')
          : (values['purchase-intent'] = this.props.inquires[type][
              'purchaseTime'
            ]['leadName']);
        values['financing'] = this.props.inquires[type]['financing'];
        values['seatCustomer'] = this.props.inquires[type]['customerSeat'];
        values['licenseRegistration'] = '';
      }
      this.props.inquires[type]['test'] == 'non' ||
      this.props.inquires[type]['test'] == null
        ? (values['testDrive'] = 'non')
        : (values['testDrive'] = 'oui');
      this.props.inquires[type]['appointment'] == null
        ? (values['prefence'] = '')
        : (values['prefence'] = this.props.inquires[type]['appointment']);
      values.modelChoice = this.props.restIntel.intel.dealerInfo.idCar;
      values.dealerChoice = this.props.restIntel.intel.dealerInfo.proFullName;
      values.postalCode = this.props.restIntel.intel.dealerInfo.zipCode;
      var iframeData = ['setData', values];
      console.log('iframeData :' + iframeData);
      window.top.postMessage(iframeData, '*');
      console.log(values);
    }
  }
  handleClick(data) {
    this.setState({
      formValidate: true
    });
    let dataLead = {
      action: 'lead',
      campaignid: 100298,
      created_at: moment().format('YYYY-MM-DD hh:mm:ss'),
      phone: this.props.inquires.user.phone_number,
      dealer: data.kvps,
      app_name: 'erdv',
      isERDV: 1
    };
    let dataRest = {
      wlName: 'seat',
      proName: 'paris17',
      origin: 'api_erdv'
    };

    this.setState({
      center: {
        lat: data.lat,
        lng: data.lng
      },
      lng: data.lng,
      data: data,
      dataLead: dataLead,
      dataRest: dataRest,
      isClicked: dataLead.dealer
    });

    console.log(this.state);
  }
  onMouseEnterHandler(i) {
    this.setState({
      isActive: i
    });
  }
  onMouseLeaveHandler() {
    this.setState({
      isActive: null
    });
  }
  calcCrow(lat1, lon1, lat2, lon2) {
    var R = 6371; // km
    var dLat = this.toRad(lat2 - lat1);
    var dLon = this.toRad(lon2 - lon1);
    var lat1 = this.toRad(lat1);
    var lat2 = this.toRad(lat2);

    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d.toFixed(2);
  }
  toRad(Value) {
    return (Value * Math.PI) / 180;
  }
  renderDealer(data) {
    if (this.props.inquires.places.lat !== null) {
      Object.keys(data).map(i => {
        data[i].distance = Number(
          this.calcCrow(
            Number(data[i].latitude),
            Number(data[i].longitude),
            this.props.inquires.places.lat,
            this.props.inquires.places.lng
          )
        );
      });
      data = _.orderBy(data, ['distance'], ['asc']);
      return _.take(data, 10);
    } else {
      return data;
    }
  }
  componentDidMount() {
    var iframeData = ['setVirtualPage', 'rdv-en-ligne/dealer_choice'];
    console.log('iframeData :' + iframeData);
    window.top.postMessage(iframeData, '*');
  }
  handleScriptLoad() {
    /*global google*/
    this.autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('autocomplete'),
      { componentRestrictions: countryRestrict }
    );
    this.autocomplete.addListener('place_changed', () =>
      this.handlePlaceSelect(this.autocomplete.getPlace())
    );
  }
  render() {
    //console.log(this.props.restIntel.intel.dealersByCars);
    var dealers = this.renderDealer(this.props.restIntel.intel.dealersByCars);
    var dealersRender = Object.keys(dealers).map(i => {
      return (
        <div
          className={
            this.state.isClicked === dealers[i].kvps
              ? 'clicked DealerButton move_4_ease'
              : 'DealerButton move_4_ease'
          }
          onClick={() =>
            this.handleClick({
              id: dealers[i].proId,
              template: dealers[i].templateId,
              proFullName: dealers[i].proFullName,
              zipCode: dealers[i].zipCode,
              street: dealers[i].street,
              city: dealers[i].city,
              lat: dealers[i].latitude,
              lng: dealers[i].longitude,
              kvps: dealers[i].kvps,
              idCar: dealers[i].serviceExternalId
            })
          }
          onMouseEnter={() => this.onMouseEnterHandler(i)}
          onMouseLeave={() => this.onMouseLeaveHandler()}
          key={'render' + i}
          style={
            this.state.isActive === i || this.state.isActive === null
              ? null
              : unactiveDealer
          }
        >
          <div className="DealerButtonTxt">
            <div className="DealerButtonTxtNom fontMedium">
              {dealers[i].proFullName}
            </div>
            <div className="DealerButtonTxtAdr fontRegular colorGrey3">
              {dealers[i].street} {dealers[i].zipCode} {dealers[i].city}
            </div>
            {this.props.inquires.places.lat !== null ? (
              <div className="DealerButtonTxtDist fontRegular colorGrey3">
                Distance : {dealers[i].distance} km
              </div>
            ) : null}
          </div>
        </div>
      );
    });

    return (
      <div className="moduleMainBodyIntel">
        <div className="pageDealerSub">
          <InputPlaces />
        </div>
        <div className="pageFormTitle fontBold colorBlack ">
          Les distributeurs les plus proches de vous :
        </div>
        <div className="DealerButtonContent">{dealersRender}</div>
        <div className="googlemap dealer">
          <GoogleMap
            center={this.state.center}
            isMarkerShown={this.state.isMarkerShown}
            containerElement={{ height: '100%' }}
            mapElement={{ height: '100%' }}
          />
        </div>
        <button
          disabled={!this.state.formValidate}
          style={this.state.formValidate ? null : unactiveBtnStyle}
          className="pageCta fontMedium colorBlack"
          onClick={this.handleSubmit}
        >
          Continuer
        </button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      dealerInfo,
      appointementClearHours,
      appointementInit,
      leadCall
    },
    dispatch
  );

export const PageDealer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassDealer);



// WEBPACK FOOTER //
// ./src/containers/PageDealer.js